import { createFileRoute } from '@tanstack/react-router'
import { SettingsScreen } from '@web/app/features/profile'
import { Settings } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/cuenta/configuracion')({
  component: SettingsScreen,
  staticData: {
    metaRoute: {
      title: 'Configuración',
      order: 3,
      icon: Settings,
    },
  },
})
